import {
  GET_JOB,
  ADD_JOB,
  UPDATE_JOB,
  DELETE_JOB,
  REQUEST_JOB,
  GET_CONTRACT_TYPES_OF_CONTACT,
  ERROR_XHR
} from '../mutation-types'

import toastr from 'toastr'

const state = {
  all: [],
  contractTypesOfContact: [],
  error: false
}

const mutations = {
  [GET_JOB] (state, jobs) {
    state.all = jobs
  },
  [ADD_JOB] (state, job) {
    state.all.push(job)
    toastr.success('L\'emploi a été créé')
  },
  [UPDATE_JOB] (state, oldJob, updatedJob) {
    state.all.$remove(oldJob)
    state.all.push(updatedJob)
    toastr.success('L\'emploi a été modifié')
  },
  [DELETE_JOB] (state, job) {
    state.all.$remove(job)
    toastr.success('L\'emploi a été supprimé')
  },
  [REQUEST_JOB] (state) {
    state.error = false
  },
  [GET_CONTRACT_TYPES_OF_CONTACT] (state, contractTypesOfContact) {
    console.log(JSON.stringify(contractTypesOfContact))
    state.contractTypesOfContact = contractTypesOfContact
  },
  [ERROR_XHR] (state, error) {
    console.log(error)
    state.error = true
    toastr.success('Une erreur s\'est produite (jobs)')
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/jobs.js